import useTranslation from "@/hooks/useTranslation";
import { useFacilityImpactTotals } from "@/pages/dashboard/hooks/useFacilityImpact";
import MetricWidget, { MetricWidgetData } from "../../components/MetricWidget/MetricWidget";
import { ImpactMetric } from "../../utils/types";

export default function FacilityImpactTotal({ metric }: { metric: ImpactMetric }) {
  const { data, isLoading, isFetching } = useFacilityImpactTotals({ metrics: [metric.key] });
  const translation = useTranslation();

  const metricWidgetData: MetricWidgetData = {
    value: data?.utility_impact[metric.key],
    comparison: {
      label: "of company total",
      value: data?.company_impact[metric.key],
    },
  };

  return (
    <MetricWidget
      title={"Facility footprint"}
      tooltip={translation["dashboard"]["facility"]["total"]}
      loading={isLoading || isFetching}
      metric={metric}
      format={metric.formatter}
      data={metricWidgetData}
    />
  );
}
